module.exports = __webpack_public_path__ + "static/media/What is Multiple Answers.ad0d6123.png";